import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'service-manage',
    loadChildren: () => import('./service-manage/service-manage.module').then( m => m.ServiceManagePageModule)
  },
  {
    path: 'search',
    loadChildren: () => import('./search/search.module').then( m => m.SearchPageModule)
  },
  {
    path: 'detail',
    loadChildren: () => import('./detail/detail.module').then( m => m.DetailPageModule)
  },
  {
    path: 'tabs/mine/sys-setting',
    loadChildren: () => import('./tab-mine/sys-setting/sys-setting.module').then( m => m.SysSettingPageModule)
  },
  {
    path: 'tabs/mine/security-center',
    loadChildren: () => import('./tab-mine/security-center/security-center.module').then( m => m.SecurityCenterPageModule)
  },
  {
    path: 'tabs/message/list',
        loadChildren: () => import('./tab-message/message-list/message-list.module').then( m => m.MessageListPageModule)
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
